import React from "react";
import classNames from "classnames";
import { Link, useLocation } from "react-router-dom";
import { RBACHidden } from "../../helpers/rbac/rbac";
import { GrafferPermissions } from "../../../application/domain/rbac/rbac";
import { GrafferUtilsR } from "../../pages/graffer-utility-tools/route";

export const MenuList: React.FC = () => {
  const { pathname } = useLocation();
  const menuData: {
    to: string;
    title: string;
    requirePermissions: GrafferPermissions;
  }[] = [
    {
      to: GrafferUtilsR.MatrixCode.link({}),
      title: "二次元コード生成",
      requirePermissions: "graffer_utility_tools.generate_matrix_code",
    },
  ];
  return (
    <nav className="menu custom-menu-list">
      <p className="menu-label">スマート申請</p>
      <ul className="menu-list">
        {menuData.map((l, index) => {
          return (
            <RBACHidden key={l.to} requirePermissions={l.requirePermissions}>
              <MenuLink
                to={l.to}
                title={l.title}
                index={index}
                isActive={pathname.startsWith(l.to)}
              />
            </RBACHidden>
          );
        })}
      </ul>
    </nav>
  );
};

const MenuLink = ({
  to,
  title,
  index,
  isActive,
}: {
  to: string;
  title: string;
  index: number;
  isActive: boolean;
}) => {
  return (
    <li key={index}>
      <Link
        className={classNames("", {
          "is-active": isActive,
        })}
        to={`${isActive ? "#" : to}`}
      >
        {title}
      </Link>
    </li>
  );
};

export default MenuList;
